export default function (config) {
  const div = document.createElement('div');

  div.style.position = 'absolute';
  div.className = config.css || '';
  div.style.left = config.left;
  div.style.width = config.width;
  div.style.height = config.height;
  div.style.lineHeight = config.height;
  div.style.top = config.top;

  if (config.html) {
    div.innerHTML = config.html;
  }

  if (config.wrapper) {
    config.wrapper.appendChild(div);
  }

  return div;
};
